/**
 * コモンクラス
 * @constructor
 */
class AboutTheGinza {
    constructor() {

    }
    /**
     * コモン
     */
    init() {
        this.slideContentsAct();
    }
    slideContentsAct() {
        let $atgBtn = $('.l-contetens__atgBtn'),
            $atgBtn2 = $('.l-contetens__atgBtn2'),
            contVal = false;

        $atgBtn.on('click', (e) => {
            if (contVal) {
                $(e.currentTarget).prev().slideUp();
                $(e.currentTarget).removeClass('is-open');
                contVal = false;
            } else {
                $(e.currentTarget).prev().slideDown(400,()=>{
                  this.frameSizeReset();
                });
                $(e.currentTarget).hide();
                // $(e.currentTarget).addClass('is-open');
                $('.l-contetens__atgCont04').addClass('is-open');
                contVal = true;
            }
        });
        // $atgBtn2.on('click', (e) => {
        //     $(e.currentTarget).prev().slideDown();
        //     $(e.currentTarget).hide();
        //     $('.l-contetens__atgCont04').addClass('is-open');
        // });
    }

  // iframe用の高さ設定の関数
  frameSizeReset() {
    if (typeof getHeightSize == 'function') {
      getHeightSize();
    }
  }
}

export default AboutTheGinza;
